import { motion } from "framer-motion";

function AnimatedPage({ children, delay }) {

    return (
        <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.4, delay: delay, ease: 'easeInOut' }}
        >
            {children}
        </motion.div>
    )
}

export default AnimatedPage